app.views.contact = app.views.base.extend({
  childEvents: {
    'change [data-comtype]': 'getComType'
  },
  attr: {
    comtype: 'data-comtype',
    availability: 'data-comfield',
    success: 'data-form-success',
    spinner: 'data-form-spinner',
    validationSummary: 'data-valmsg-summary'
  },
  /**
   * Initialise Contact ViewListener
   * Listens for the contact page being loaded by the browser.
   * @public
   * @constructor
   */

  init: function init() {},
  onSuccessfulSubmission: function onSuccessfulSubmission(id, isAccessedFromMobileApp) {
    var form = $(id);
    var errors = form.find('.validation-summary-errors');
    if (errors.length < 1) {
      if (isAccessedFromMobileApp) {
        window.location = "/app/submit-success";
      } else {
        $('[' + this.attr.success + ']').show();
      }
      form.trigger('reset');
      form.find('input[type=text], textarea').val('');
      dataLayer.push({
        event: 'formSubmission',
        formType: 'Contact'
      });
    }
    app.initElementListeners('#ContactFormContainer');
  },
  onFailedSubmission: function onFailedSubmission() {
    $('[' + this.attr.spinner + ']').hide();
    var vs = $('[' + this.attr.validationSummary + ']');
    $(vs).children('ul').empty();
    vs.children('ul').append($('<li></li>').text("There has been an error submitting the contact form. Please try again later."));
    window.scrollTo(0, 0);
  },
  showAvailabilityField: function showAvailabilityField($field) {
    $field.parent().show();
  },
  hideAvailabilityField: function hideAvailabilityField($field) {
    $field.parent().hide();
  },
  getComType: function getComType(e) {
    var $elm = $(this.getActiveComType(e));
    var $field = this.getAvailabilityField();
    if ($elm.attr(this.attr.comtype) === 'phone') {
      this.showAvailabilityField($field);
    } else {
      this.hideAvailabilityField($field);
    }
  },
  getActiveComType: function getActiveComType(e) {
    return e.currentTarget;
  },
  getAvailabilityField: function getAvailabilityField() {
    return $('[' + this.attr.availability + '="availability"]');
  }
});